import { cleanQueryResult, getQueryString } from 'helpers/chartHelper';
import { transformQueryToDataQuery } from 'helpers/queryHelpers';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

type GetDataQueryResult = {
    columns: ResponseColumnT[];
    data: ResponseDataT[];
};

/** Hook to fetch data for a given explore query.  */
export const useQueryGetData = (
    query: QueryT,
    cacheKey?: QueryKey,
    params: Partial<UseQueryOptions<GetDataQueryResult, HttpError>> = {},
) => {
    const queryKey: QueryKey = cacheKey ?? [getQueryString(query)];
    return useQuery<GetDataQueryResult, HttpError>({
        queryKey,
        queryFn: async () => {
            const response = await RQAPICallWithData<GetDataQueryResult>({
                endpoint: `query/get_data/v2`,
                method: 'POST',
                body: transformQueryToDataQuery(query),
            });
            const { data } = response.content;
            const result = cleanQueryResult({
                queryMetrics: query.metrics,
                queryDimensions: query.dimensions,
                columns: data?.columns,
                data: data?.data,
            });
            return result;
        },
        ...params,
    });
};
